/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'

yup.setLocale({
  mixed: {
    required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
  },
  string: {
    max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
  }
})

const ValidationSchema = () => {
  return yup.object().shape({
    id: yup.number().nullable(),
    opacity: yup
      .number()
      .nullable()
      .default(() => 0.5),
    rotateAngle: yup
      .number()
      .default(() => 0)
      .nullable(),
    textAlignment: yup
      .number()
      .default(() => 1)
      .nullable(),
    horizontalAlignment: yup
      .number()
      .default(() => 1)
      .nullable(),
    verticalAlignment: yup
      .number()
      .default(() => 1)
      .nullable(),
    fontStyle: yup
      .number()
      .default(() => 0)
      .nullable(),
    fontSize: yup
      .number()
      .default(() => 8)
      .nullable(),
    name: yup
      .string()
      .trim()
      .max(255)
      .required()
      .default(() => ''),
    description: yup
      .string()
      .max(255)
      .nullable()
      .default(() => ''),
    foregroundColor: yup
      .string()
      .max(255)
      .nullable()
      .default(() => '#000000'),
    stampText: yup
      .string()
      .required()
      .default(() => '')
  })
}

export default ValidationSchema
